import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import * as featureActions from '../../index';
import {Store, select, Action} from '@ngrx/store';
import {DevicesService} from '../../../services/devices.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import {CryptoService} from '../../../services/crypto.service';
import {AddUpdateDeviceParams} from '../../../models/devices';
import { BindEmbCardActionTypes, BindEmbCardActions } from '../actions/bind-emb-card.actions';


@Injectable()
export class BindEmbCardEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);
  private cryptoService = inject(CryptoService);

  constructor() {}

  GetBindEmbCards$ = createEffect(() => this.actions$.pipe(
    ofType(BindEmbCardActionTypes.GetBindEmbCards),
    map((action: any) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const newMac = payload.mac.replace(/ - /g, '').substr(-6); // Get last 6 numbers.
      const newKey = this.cryptoService.hashHmacSha1(newMac).substr(0, 20); // Compare the input.
      const originalKey = payload.key.replace(/ - /g, '');
      // NgRx 9 不可變性: 直接在 params 中計算 key，不修改 payload
      const validatedKey = (originalKey.toUpperCase() !== newKey.toUpperCase()) ? '' : originalKey.toUpperCase();
      const params = {
        otp: user.otp,
        mac: newMac,
        key: validatedKey,
        RegionId: payload.RegionId
      };
      return this.deviceService.addEmbDevice(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.BindEmbCard };
          // 0:add success but no device
          // 1:add success and need to add device
          // 3:mac and key is not match
          // 4:duplicate scan in same account(offline)
          // 5:duplicate scan in same account(online)
          // 6:duplicate scan in same account(n/a)
          // 7:duplicate scan in diff account(no device)
          // 8:duplicate scan in diff account(with device)
          if (result.result) {
            if (result.msg.result_code === 1 && result.msg.lastest_log) {
              const param = JSON.parse(result.msg.lastest_log),
                parseObj = {
                  Model: param.hasOwnProperty('Model') ? param.Model : '',
                  DeviceSn: param.hasOwnProperty('SN') ? param.SN : '',
                  FV: param.hasOwnProperty('FV') ? param.FV : ''
                };
              const data: AddUpdateDeviceParams = {
                LoginType: 10, // Web Login
                DeviceType: 0, // UPS
                Model: parseObj.Model,
                DeviceSn: parseObj.DeviceSn,
                FirmwareVersion: parseObj.FV,
                rSN: newMac,
                rType: 3, // 1: Wifi Card, 2: Mini Card, 3: Emb Card,
                DeviceSubtype: result.msg.DeviceSubtype
              };
              return [new featureActions.LoadBindMiniCards(data), new featureActions.UpdateInfoSuccessAction(result)];
            } else {
              return [new featureActions.UpdateInfoSuccessAction(result)];
            }
          } else {
            return [new featureActions.UpdateInfoFailAction(result), new featureActions.ClearEmbCards()];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.BindEmbCard
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));



}
